export const seasonStageExportFields = [
  {
    titleIntlKey: "seasonStages.columns.competition.title",
    fields: ["competitionId", "competitionExternalId", "competitionName"],
  },
  {
    titleIntlKey: "seasonStages.columns.season.title",
    fields: ["seasonId", "seasonExternalId", "seasonName"],
  },
  {
    titleIntlKey: "seasonStages.columns.stage.title",
    fields: ["nameLocal", "nameLatin", "abbreviationLocal", "abbreviationLatin", "externalId", "stageCode", "stageOrder"],
  },
];

export const defaultSeasonStageExportFieldNames = ["nameLocal", "stageCode", "stageOrder"];
